import axios from "axios";
import CryptoJS from "crypto-js";
import configService from "./ducter-energy";

const ducter_energyServices = axios.create({
  baseURL: configService.apiUrl,
  headers: {
    common: {
      "Api-Key": configService.api_key,
      ...(configService.enable_decryption
        ? { "X-Decrypt-Responses": configService.enable_decryption }
        : {}),
    },
  },
});

var key = configService.api_decrypt_key;

export default {
  install: (app, options) => {
    // Add a response interceptor
    ducter_energyServices.interceptors.response.use(
      function (response) {
        // Check if response decryption is configured
        if (configService.enable_decryption) {
          var encrypted_json = JSON.parse(atob(response.data));

          var decrypted = CryptoJS.AES.decrypt(
            encrypted_json.value,
            CryptoJS.enc.Base64.parse(key),
            {
              iv: CryptoJS.enc.Base64.parse(encrypted_json.iv),
            }
          );

          const new_obj = {
            ...response,
            data: JSON.parse(decrypted.toString(CryptoJS.enc.Utf8)),
          };

          return new_obj;
        }
      },
      function (error) {
        // Check if response decryption is configured
        if (configService.enable_decryption) {
          if (error.response) {
            if (error.response.status == 404) {
              return Promise.reject(error.response);
            }

            if (error.response.status == 401) {
              return Promise.reject(error.response);
            }

            var Error_encrypted_json = JSON.parse(atob(error.response.data));

            var decryptedError = CryptoJS.AES.decrypt(
              Error_encrypted_json.value,
              CryptoJS.enc.Base64.parse(key),
              {
                iv: CryptoJS.enc.Base64.parse(Error_encrypted_json.iv),
              }
            );

            const new_obj = {
              ...error.response,
              data: JSON.parse(decryptedError.toString(CryptoJS.enc.Utf8)),
            };

            return Promise.reject(new_obj);
          } else if (error.request) {
            return Promise.reject({
              status: null,
              error: {
                message:
                  "Conexión rechazada con nuestros servidores. Código de error: 000001",
              },
            });
          } else {
            return Promise.reject({
              status: null,
              error: {
                message:
                  "Ha ocurrido un error inesperado, por favor vuelve a intentarlo. Código de error: 000000",
              },
            });
          }
        }
      }
    );

    app.config.globalProperties.$ducter_energyServices = ducter_energyServices;
  },
};

export { ducter_energyServices };



// WEBPACK FOOTER //
// ./src/services/axios_ducter_energy.js